import apiClient from './client'

export interface ErrorLogItem {
  id: number
  created_at: string
  updated_at: string | null
  onde: string | null
  ambiente: string | null
  empresa_id: number | null
  grupo_id: number | null
  gravidade: string
  providencia_tomada: string | null
  corrigido: boolean | null
  corrigido_em: string | null
  request_id: string | null
}

export interface ErrorLogDetail extends ErrorLogItem {
  details: Record<string, unknown> | null
  user_id: number | null
  actor_id: number | null
}

export interface ErrorLogListParams {
  ambiente?: string | null
  gravidade?: string | null
  corrigido?: boolean | null
  empresa_id?: number | null
  since?: string | null
  until?: string | null
  skip?: number
  limit?: number
}

export interface ErrorLogUpdateBody {
  providencia_tomada?: string | null
  corrigido?: boolean | null
  gravidade?: string | null
}

export const errorLogApi = {
  list: async (params?: ErrorLogListParams): Promise<ErrorLogItem[]> => {
    const query: Record<string, unknown> = {}
    if (params?.ambiente) query.ambiente = params.ambiente
    if (params?.gravidade) query.gravidade = params.gravidade
    if (params?.corrigido !== undefined && params?.corrigido !== null) query.corrigido = params.corrigido
    if (params?.empresa_id != null) query.empresa_id = params.empresa_id
    if (params?.since) query.since = params.since
    if (params?.until) query.until = params.until
    query.skip = params?.skip ?? 0
    query.limit = params?.limit ?? 50
    const res = await apiClient.get<ErrorLogItem[]>('/log-erros', { params: query })
    return res.data
  },

  getById: async (id: number): Promise<ErrorLogDetail> => {
    const res = await apiClient.get<ErrorLogDetail>(`/log-erros/${id}`)
    return res.data
  },

  update: async (id: number, body: ErrorLogUpdateBody): Promise<ErrorLogItem> => {
    const res = await apiClient.patch<ErrorLogItem>(`/log-erros/${id}`, body)
    return res.data
  },
}
